(function () {
  // KJ: Produktmotive in Karten gleichmaessig gross darstellen (Bild bleibt unveraendert, nur Ausschnitt/Skalierung)
  var TARGET = 0.84, MAXZ = 1.5, MINZ = 0.88, N = 72;
  var SEL = '.card__media img, #recently-viewed-products img';
  function analyse(img) {
    if (img.dataset.kjFit || !img.complete || !img.naturalWidth) return;
    if (!img.matches(SEL)) return;
    img.dataset.kjFit = '1';
    try { fit(img, img); } catch (e) {
      // Bild von anderer Domain (z.B. cdn.shopify.com): Kopie mit CORS laden und damit messen
      var copy = new Image(); copy.crossOrigin = 'anonymous';
      copy.onload = function () { try { fit(copy, img); } catch (e2) {} };
      copy.src = img.currentSrc || img.src;
    }
  }
  function fit(src, img) {
    {
      var c = document.createElement('canvas'); c.width = N; c.height = N;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(src, 0, 0, N, N);
      var d = x.getImageData(0, 0, N, N).data;
      var px = function (u, v) { var k = (v * N + u) * 4; return [d[k], d[k + 1], d[k + 2]]; };
      // Hintergrund = hellste Ecke
      var corners = [px(1, 1), px(N - 2, 1), px(1, N - 2), px(N - 2, N - 2)];
      corners.sort(function (a, b) { return (b[0] + b[1] + b[2]) - (a[0] + a[1] + a[2]); });
      var bg = corners[0];
      if (bg[0] + bg[1] + bg[2] < 600) return; // kein heller Hintergrund -> nichts tun
      var cols = new Array(N).fill(0), rows = new Array(N).fill(0);
      for (var v = 0; v < N; v++) for (var u = 0; u < N; u++) {
        var p = px(u, v);
        var diff = Math.abs(p[0] - bg[0]) + Math.abs(p[1] - bg[1]) + Math.abs(p[2] - bg[2]);
        if (diff > 45) { cols[u]++; rows[v]++; }
      }
      var edge = function (arr, from, step) { for (var k = from; k >= 0 && k < N; k += step) if (arr[k] > 1) return k; return -1; };
      var x0 = edge(cols, 0, 1), x1 = edge(cols, N - 1, -1), y0 = edge(rows, 0, 1), y1 = edge(rows, N - 1, -1);
      if (x0 < 0 || y0 < 0) return;
      var bw = (x1 - x0 + 1) / N, bh = (y1 - y0 + 1) / N, size = Math.max(bw, bh);
      if (size < 0.15) return;
      // Nur bei rein weissem Hintergrund verkleinern bzw. ueber den Bildrand verschieben (sonst sieht man Kanten)
      var pureWhite = bg[0] > 250 && bg[1] > 250 && bg[2] > 250;
      var s = Math.min(MAXZ, Math.max(pureWhite ? MINZ : 1, TARGET / size));
      if (Math.abs(s - 1) < 0.04) s = 1;
      var cx = (x0 + x1 + 1) / 2 / N, cy = (y0 + y1 + 1) / 2 / N;
      var lim = Math.max(0, (s - 1) / 2) + (pureWhite ? 0.04 : 0);
      var tx = Math.max(-lim, Math.min(lim, s * (0.5 - cx)));
      var ty = Math.max(-lim, Math.min(lim, s * (0.5 - cy)));
      if (s === 1 && Math.abs(tx) < 0.02 && Math.abs(ty) < 0.02) return;
      if (pureWhite && img.parentElement) img.parentElement.style.backgroundColor = '#fff';
      img.style.setProperty('scale', String(s));
      img.style.setProperty('translate', (tx * 100).toFixed(2) + '% ' + (ty * 100).toFixed(2) + '%');
      if (s > 1 && img.srcset) {
        var w = img.getBoundingClientRect().width || img.width;
        if (w) img.sizes = Math.ceil(w * s) + 'px';
      }
    }
  }
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') analyse(e.target); }, true);
  function scan() { document.querySelectorAll(SEL).forEach(analyse); }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  new MutationObserver(function () { clearTimeout(window.__kjFitT); window.__kjFitT = setTimeout(scan, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
